import React, { useCallback, useState,useEffect  } from "react";
import { Link,useHistory } from "react-router-dom";
import { Modal,ModalHeader,ModalBody,ModalFooter,Button,ListGroup,ListGroupItem } from "reactstrap";
import { getSessionDataOnlyRead } from "utils/common";
import UpDownArrow from '../../assets/img/icons/up_down.svg'
import { useDispatch, useSelector } from "react-redux";
import { setIsOrderBookGet } from "store/reducers/orderbook.slice";
import { setIsTradeBookGet } from "store/reducers/tradeBook.slice";
import { setIsPositionGet, setPositionReportFilterValue } from "store/reducers/positionReport.slice";
import { setIsQuantityGet } from "store/reducers/settingsSlice/setting.slice";
import { setIsSettingOptionStrikeGet } from "store/reducers/settingsSlice/settingOptionStrikeValidation.slice";
import { setIsSettingSymbolMaxValueGet } from "store/reducers/settingsSlice/settingSymbolMaxValue.slice";
import { setIsSettingClientSymbolGet } from "store/reducers/settingsSlice/settingClientSegment.slice";
import { setIsSettingClientOrderLimitGet } from "store/reducers/settingsSlice/settingClientOrderLimit.slice";
import { setHomeDashboardList } from "store/reducers/home.slice";
import { setIsFilterRejectionLogData, setIsFilterDataUpdateLog } from "store/reducers/report.slice";
import { logOut, setUserDevice } from "store/reducers/auth.slice";
import "../../assets/scss/mobile/newStyleMobile.scss";
import bankicon from "assets/img/icons/bank_card_icon.png";
import paymentIcon from "assets/img/icons/online-payment.png";
import { setRulesAccepted } from "store/reducers/auth.slice";
import { setIsShowChangePassword } from "store/reducers/auth.slice";
import { getAvailableBalance,getRangeList,getPayInOutList,showMessage,addFund,withdrawFund,leoPayIn} from "store/reducers/common.slice";

export default function MobileNewUserProfile() {
  const dispatch = useDispatch();
  const history = useHistory();
  const { userIp, isMasterRole,userRole} = useSelector(({ auth }) => auth);
  const {
    availableBalance,
    amountRangeList,
    whatappRecords,
    paymentGetway,
    isAddFund,
    addFundLoading,
    iswithdrawFund,
    withdrawFundLoading,
    payInList,
    payOutList,
    totalPayInRecord,
    totalPayOutRecord,
    payInOutListLoading,
  } = useSelector(({ common }) => common);
  const [switchUser, setSwitchUser] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedRange, setSelectedRange] = useState("");
  const [isLeoPayModalOpen, setIsLeoPayModalOpen] = useState(false);
  const [leoamount, setleoAmount] = useState("");
  useEffect(() => {
    if (userRole === "User") {
      dispatch(getAvailableBalance());
    }
  }, [dispatch]);
  const toggleModal = () => {
    if (!isModalOpen) {
      setSelectedRange("");
      dispatch(getRangeList());
    }
    setIsModalOpen(!isModalOpen);
  };
  const handleRangeSelect = (item) => {
    setSelectedRange(item);
  };
  const handleSubmit = () => {
  if (selectedRange?.paymentGetwayName === 'LeoPay') {
    setIsModalOpen(false);
    setIsLeoPayModalOpen(true);
    setleoAmount("");
  } else if (selectedRange?.whatsAppNumber) {
    const whatsappURL = `https://wa.me/${selectedRange.whatsAppNumber}?text=Hello,%20I%20want%20to%20add%20points.`;
    window.open(whatsappURL, "_blank"); // Open in new tab
  } else {
      history.push("/app/add-fund", { selectedRange: selectedRange });
    }
  };
  const handleClose = () => setSwitchUser(false);
  const handleShow = () => setSwitchUser(true);
  const handleLogOut = useCallback(async () => {
    await dispatch(setIsOrderBookGet(false));
    await dispatch(setIsTradeBookGet(false));
    await dispatch(setIsPositionGet(false));
    await dispatch(setPositionReportFilterValue({}));
    await dispatch(setIsQuantityGet(false));
    await dispatch(setIsSettingOptionStrikeGet(false));
    await dispatch(setIsSettingSymbolMaxValueGet(false));
    await dispatch(setIsSettingClientSymbolGet(false));
    await dispatch(setIsSettingClientOrderLimitGet(false));
    await dispatch(setIsFilterRejectionLogData(false));
    await dispatch(setIsFilterDataUpdateLog(false));
    await dispatch(setHomeDashboardList([]));
    await dispatch(logOut({ userIp }));
    await dispatch(setUserDevice(""));
    await dispatch(setRulesAccepted(true));
    await dispatch(setIsShowChangePassword(false));
    // window.location.reload();
  }, [dispatch, userIp]);
  let sessionData = getSessionDataOnlyRead();
    useEffect(() => {
    if (isAddFund) {
      setleoAmount("");
      setIsLeoPayModalOpen(false); 
    }
  }, [isAddFund]);
  return (
    <div className="muser_profile_wrap">
      <header className="text-center">
        <div className="userprofile_header">
           <h6 className="text_mediam fw_bold m-0">{sessionData?.userName}</h6>
              <small className="user_name_small">{sessionData?.userCode}</small>
        </div>
      </header>
      <main>
        <div className="userprofile_main_wrap">
        {userRole === "User" && (
          <div className="userprofile_top card">
            <p className="mt-2 mb-1">Available Balance</p>
            <strong className="balance_amount" style={{ color: availableBalance?.balance > 0 ? 'green' : 'red' }}>{availableBalance?.balance} {availableBalance?.crDr}</strong>
            <p className="mt-0 mb-2">
              <Link to={isMasterRole ? "/app/view-statement" : "#"} className="text-primary text-decoration-underline">
                 <img src="https://cdn-icons-png.flaticon.com/128/893/893220.png" alt="statement icon" width="18" height="18" className="me-1"/> &nbsp;View Statement
              </Link>
            </p>
          </div>
          )}
        {userRole === "User" && (
         <div className="userprofile_top card p-2">
            <div style={{ display: 'flex', justifyContent: 'space-evenly' }}>
              <div className="me-2">
                  <button className="btn btn-primary" onClick={toggleModal} disabled={!isMasterRole}>ADD POINTS</button>
              </div>
              <div>
                <Link to={isMasterRole ?"/app/withdrawal":"#"} className="text-decoration-none">
                  <button className="btn btn-primary" disabled={!isMasterRole}>WITHDRAW</button>
                </Link>
              </div>
            </div>
          </div>
           )}
          <div className={`userprofile_detail ${userRole !== "User" ? "mt-4" : ""}`}>
            <ul>
            {isMasterRole && (
              <li>
                <Link to="/app/change-password" className="blue_box_wrap">
                  <div className="detail_left">
                    <div className="profile_icon_wrap">
                      <span className="material-symbols-outlined profile_icon">
                        lock_open
                      </span>
                    </div>
                    Change Password
                  </div>
                  <span className="material-symbols-outlined arrow_icon">
                    navigate_next
                  </span>
                </Link>
              </li>)
              }
              <li>
                <Link to="/app/trade-report" className="blue_box_wrap">
                  <div className="detail_left">
                    <div className="profile_icon_wrap">
                      <span className="material-symbols-outlined profile_icon">
                        description
                      </span>
                    </div>
                    Trade Report
                  </div>
                  <span className="material-symbols-outlined arrow_icon">
                    navigate_next
                  </span>
                </Link>
              </li>
               <li>
                <Link to="/app/ledger-report" className="blue_box_wrap">
                  <div className="detail_left">
                    <div className="profile_icon_wrap">
                      <span className="material-symbols-outlined profile_icon">
                        description
                      </span>
                    </div>
                    Ledger Report
                  </div>
                  <span className="material-symbols-outlined arrow_icon">
                    navigate_next
                  </span>
                </Link>
              </li>
              <li>
                <Link to="/app/rejection-logs" className="blue_box_wrap">
                  <div className="detail_left">
                    <div className="profile_icon_wrap">
                      <span className="material-symbols-outlined profile_icon">
                        history
                      </span>
                    </div>
                    Rejection Logs
                  </div>
                  <span className="material-symbols-outlined arrow_icon">
                    navigate_next
                  </span>
                </Link>
              </li>
              <li>
                <Link
                  to="/app/trade-edit-delete-logs"
                  className="blue_box_wrap"
                >
                  <div className="detail_left">
                    <div className="profile_icon_wrap">
                      <span className="material-symbols-outlined profile_icon">
                        history
                      </span>
                    </div>
                    Trade edit/Delete Logs
                  </div>
                  <span className="material-symbols-outlined arrow_icon">
                    navigate_next
                  </span>
                </Link>
              </li>
              <li>
                <Link to="/app/banned-block-script" className="blue_box_wrap">
                  <div className="detail_left">
                    <div className="profile_icon_wrap">
                      <img src={UpDownArrow} alt="UpDownArrow" />
                    </div>
                    Banned/Blocked Scripts
                  </div>
                  <span className="material-symbols-outlined arrow_icon">
                    navigate_next
                  </span>
                </Link>
              </li>
              <li>
                <Link to="/app/qty-setting" className="blue_box_wrap">
                  <div className="detail_left">
                    <div className="profile_icon_wrap">
                      <span className="material-symbols-outlined profile_icon">
                        question_mark
                      </span>
                    </div>
                    Qty Setting
                  </div>
                  <span className="material-symbols-outlined arrow_icon">
                    navigate_next
                  </span>
                </Link>
              </li>
              <li>
                <Link to="/app/rules" className="blue_box_wrap">
                  <div className="detail_left">
                    <div className="profile_icon_wrap">
                      <span className="material-symbols-outlined profile_icon">
                        filter_list
                      </span>
                    </div>
                    Rules
                  </div>
                  <span className="material-symbols-outlined arrow_icon">
                    navigate_next
                  </span>
                </Link>
              </li>
              <li>
                <span
                  onClick={handleShow}
                  className="blue_box_wrap"
                >
                  <div className="detail_left">
                    <div className="profile_icon_wrap">
                      <span className="material-symbols-outlined profile_icon">
                        power_settings_new
                      </span>
                    </div>
                    Logout
                  </div>
                  <span className="material-symbols-outlined arrow_icon">
                    navigate_next
                  </span>
                </span>
              </li>
            </ul>
          </div>
        </div>
      </main>
      <Modal
        className="modal-dialog-centered custom_model"
        centered
        style={{ zIndex: 999999 }}
        isOpen={switchUser}
      >
        <div className="model_content_wrap log_out_text">
          <p className="log_out_text">
            Are you sure want to logout ?
          </p>
          <div className="footer_btn_wrap">
            <ul className="d-flex justify-content-end">
              <li>
                <button type="button" className="trans_btn mr-2" onClick={handleClose}>
                  CANCEL
                </button>
              </li>
              <li>
                <button type="button" className="trans_btn" onClick={() => handleLogOut()}>
                  LOGOUT
                </button>
              </li>
            </ul>
          </div>
        </div>
      </Modal>
      <Modal isOpen={isModalOpen} toggle={toggleModal} centered>
        <ModalHeader toggle={toggleModal} className="w-100 text-center border-0">ADD POINT</ModalHeader>
        <ModalBody>
          <ListGroup>
            {amountRangeList.map((item, index) => (
              <ListGroupItem key={item.id} onClick={() => handleRangeSelect(item)} style={{display: "flex", alignItems: "center", cursor: "pointer", border: "none", padding: "10px 15px", position: "relative", }} >
                <img src={bankicon} alt="icon" style={{ width: "30px", height: "30px", marginRight: "10px" }} />
                <div style={{ flex: 1 }}>{item.bankName} (₹{item.startAmountRange} - ₹{item.endAmountRange})</div>
                {selectedRange?.id === item.id && (<span style={{ fontWeight: "bold", color: "green", fontSize: "20px" }}>✔</span> )}
              </ListGroupItem>
            ))}
          </ListGroup>
          {paymentGetway.length > 0 &&
            paymentGetway.map((gateway, idx) => (
              <ListGroupItem
                key={idx}
                onClick={() => handleRangeSelect(gateway)}
                style={{
                  display: "flex",
                  alignItems: "center",
                  cursor: "pointer",
                  border: "none",
                  padding: "10px 15px",
                  position: "relative",
                }}
              >
                <img
                  src={paymentIcon}
                  alt="Gateway"
                  style={{ width: "30px", height: "30px", marginRight: "10px" }}
                />
                <div style={{ flex: 1 }}>{gateway.paymentGetwayName} - Pay Online</div>
                {selectedRange?.paymentGetwayName === gateway.paymentGetwayName && (
                  <span
                    style={{
                      fontWeight: "bold",
                      color: "green",
                      fontSize: "20px",
                    }}
                  >
                    ✔
                  </span>
                )}
              </ListGroupItem>
            ))}
          {whatappRecords.length > 0 && whatappRecords.map((whatsApp) => (
            <ListGroup>
              <ListGroupItem key={whatsApp.id} onClick={() => handleRangeSelect(whatsApp)} style={{display: "flex", alignItems: "center", cursor: "pointer", border: "none", padding: "10px 15px", position: "relative", }} >
                <img src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg" alt="WhatsApp" style={{ width: "30px", height: "30px", marginRight: "10px" }} />
                <div style={{ flex: 1 }}>Add Point via WhatsApp</div>
                {selectedRange?.id === whatsApp.id && (<span style={{ fontWeight: "bold", color: "green", fontSize: "20px" }}>✔</span> )}
              </ListGroupItem>
            </ListGroup> 
            ))}
        </ModalBody>
          <ModalFooter>
            <Button className="w-100 btn-icon btn-3 mt-0" color="default" disabled={!selectedRange} onClick={handleSubmit}>
              Submit
            </Button>
          </ModalFooter>
      </Modal>
      <Modal isOpen={isLeoPayModalOpen} toggle={() => setIsLeoPayModalOpen(false)}>
      <ModalHeader toggle={() => setIsLeoPayModalOpen(false)}>Pay Online</ModalHeader>
      <ModalBody>
        <div className="form-group">
          <label htmlFor="leoamount">Enter Amount</label>
          <input
            type="number"
            id="leoamount"
            className="form-control"
            placeholder="Enter amount"
            min={500}
            value={leoamount}
            onChange={(e) => setleoAmount(e.target.value)}
          />
          {leoamount && leoamount < 500 && (
            <small className="text-danger">Minimum amount is 500</small>
          )}
        </div>
      </ModalBody>
      <ModalFooter>
        <Button
          color="success"
          onClick={() => dispatch(leoPayIn({ amount: leoamount }))}
          disabled={!leoamount}
        >
          Submit & Pay
        </Button>
      </ModalFooter>
    </Modal>
    </div>
  );
}
